export default __webpack_public_path__ + "static/media/microsoft-authenticator.27708ace.svg";